import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export interface EmailPreview {
  html: string;
  subject: string;
  scenarioName: string;
  /**
   * Backend-driven signal: `false` means the scenario has no live template yet
   * (work in progress). Older backends may omit it, so treat `undefined` as
   * "infer from html".
   */
  previewAvailable?: boolean;
}

interface GetEmailPreviewParams {
  scenarioId: string;
  logoUrl?: string;
}

export const getEmailPreviewAPI = async (params: GetEmailPreviewParams) => {
  const queryParams = params.logoUrl
    ? `?logoUrl=${encodeURIComponent(params.logoUrl)}`
    : '';
  const response = await baseAPI.get<EmailPreview>(
    `/email/toggles/${params.scenarioId}/preview${queryParams}`,
  );
  return response.data;
};

export const useGetEmailPreview = (
  params: GetEmailPreviewParams & { enabled?: boolean },
) => {
  const { enabled = true, ...queryParams } = params;
  return useQuery({
    queryKey: [
      KEYS.EMAIL_TOGGLE_PREVIEW,
      queryParams.scenarioId,
      queryParams.logoUrl ?? null,
    ],
    queryFn: () => getEmailPreviewAPI(queryParams),
    enabled: enabled && !!queryParams.scenarioId,
    staleTime: 5 * 60 * 1000,
  });
};
